/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRoleAssignmentError
 */
export interface UpdateRoleAssignmentError {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleAssignmentError
     */
    securityGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleAssignmentError
     */
    message: string;
}

/**
 * Check if a given object implements the UpdateRoleAssignmentError interface.
 */
export function instanceOfUpdateRoleAssignmentError(value: object): value is UpdateRoleAssignmentError {
    if (!('securityGroupId' in value) || value['securityGroupId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function UpdateRoleAssignmentErrorFromJSON(json: any): UpdateRoleAssignmentError {
    return UpdateRoleAssignmentErrorFromJSONTyped(json, false);
}

export function UpdateRoleAssignmentErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoleAssignmentError {
    if (json == null) {
        return json;
    }
    return {
        
        'securityGroupId': json['securityGroupId'],
        'message': json['message'],
    };
}

export function UpdateRoleAssignmentErrorToJSON(json: any): UpdateRoleAssignmentError {
    return UpdateRoleAssignmentErrorToJSONTyped(json, false);
}

export function UpdateRoleAssignmentErrorToJSONTyped(value?: UpdateRoleAssignmentError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'securityGroupId': value['securityGroupId'],
        'message': value['message'],
    };
}

